import { endpointDeclaration } from '@moojo/endpoints'
import { z } from 'zod'
export const EnrichUserRequest = z.object({ identifier: z.string(), type: z.literal('phone').or(z.literal('email')) })

export type EnrichUserRequest = z.infer<typeof EnrichUserRequest>

export const EnrichUserResponse = z.record(z.string(), z.never())

export type EnrichUserResponse = z.infer<typeof EnrichUserResponse>

export const enrichUserDeclaration = endpointDeclaration(EnrichUserRequest, EnrichUserResponse)
